export const cdnUrl = 'https://fuel-ds.fretebras.com.br';
